import { type MouseEvent, memo } from 'react';

import { ChevronDownIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_GROUP_ICONS } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantSizeIcons';

export type WorkspaceAgentGuidedVariantSizeGroupToggleProps = {
  groupId: string;
  isExpanded: boolean;
  label: string;
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const WorkspaceAgentGuidedVariantSizeGroupToggle = memo(
  ({ groupId, isExpanded, label, onToggle }: WorkspaceAgentGuidedVariantSizeGroupToggleProps) => {
    const Icon = WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_GROUP_ICONS[groupId];

    return (
      <button
        aria-expanded={isExpanded}
        className="flex min-h-8 w-full items-center gap-2 rounded-4 px-1.5 text-left text-14 hover:bg-gray-4"
        data-group-id={groupId}
        data-testid="WORKSPACE_AGENT_GUIDED_VARIANT_SMART_RESIZE_GROUP"
        onClick={onToggle}
        type="button"
      >
        {Icon ? <Icon aria-hidden className="size-4 shrink-0 text-gray-10" /> : null}
        <span className="min-w-0 flex-1 truncate text-gray-10">{label}</span>
        <ChevronDownIcon aria-hidden className={cn('size-4 shrink-0 text-gray-9', isExpanded && 'rotate-180')} />
      </button>
    );
  },
);

WorkspaceAgentGuidedVariantSizeGroupToggle.displayName = 'WorkspaceAgentGuidedVariantSizeGroupToggle';
